import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DeleteBeegoAppointmentFormFactory } from '@internal-factories/forms/delete-beego-appointment-form.factory';
import { IBeegoAppointment, IDeleteBeegoAppointment } from '@internal-models/beego-appointment.model';
import { BeegoAppointmentProvider } from '@internal-providers/beego-appointment.provider';
import { NavigationDataKey } from '@shared-libs/enums';
import { formIsValid, translate } from '@shared-libs/helpers';
import { IFormGroup } from '@shared-libs/interfaces';
import { MessageService } from '@shared-services/message.service';
import { NavigationService } from '@shared-services/navigation.service';
import { ValidationService } from '@shared-services/validation.service';
import { differenceInHours } from 'date-fns';

@Component({
	selector: 'cancel-beego-appointment-component',
	templateUrl: 'cancel-beego-appointment.component.html',
	styleUrls: ['./cancel-beego-appointment.component.scss'],
})
export class CancelBeegoAppointmentComponent implements OnInit {
	public beegoAppointment: IBeegoAppointment;
	public appointmentDate: Date;
	public deleteAppointmentForm: IFormGroup<IDeleteBeegoAppointment>;
	public communication: Array<{ control: FormControl; label: string }>;
	public reason: string;
	public confirmation: boolean = false;
	public distanceToNow: number;

	constructor(
		private readonly navigationService: NavigationService,
		private readonly beegoAppointmentProvider: BeegoAppointmentProvider,
		private readonly messageService: MessageService,
		private readonly validationService: ValidationService
	) {}

	public async ngOnInit(): Promise<void> {
		this.beegoAppointment = this.navigationService.getNavigationData(NavigationDataKey.beegoAppointment);
		this.deleteAppointmentForm = DeleteBeegoAppointmentFormFactory.create(this.beegoAppointment);
		this.getCommunicationItems();

		this.appointmentDate = new Date(
			`${this.beegoAppointment.WorkOrder.Appointment.appointmentDate} ${this.beegoAppointment.WorkOrder.Appointment.appointmentTime}`
		);
		this.distanceToNow = differenceInHours(this.appointmentDate, new Date());
	}

	public async deleteAppointment(confirm?: boolean): Promise<void> {
		if (formIsValid(this.deleteAppointmentForm)) {
			if (confirm) {
				if (!(await this.validationService.actionIsConfirmed('BEEGO_CANCEL_LT_24H'))) {
					return;
				}
			}

			await this.beegoAppointmentProvider.cancel(this.deleteAppointmentForm.value);
			const cancelledBeegoAppointment = await this.beegoAppointmentProvider.getOne(
				this.beegoAppointment.AppointmentId
			);
			this.messageService.showSavedMessage(translate('BEEGO_APPOINTMENT.DETAILS.CANCELLED.CONFIRMATION'));
			this.navigationService.navigateBack({ beegoAppointment: cancelledBeegoAppointment });
		}
	}

	public close(): void {
		this.navigationService.navigateBack();
	}

	private getCommunicationItems(): void {
		let keys: Array<string> = Object.keys((this.deleteAppointmentForm.get('Communication') as FormGroup).controls);
		const employeeIndex: number = keys.indexOf('employee');
		if (!(employeeIndex < 0)) {
			keys.splice(employeeIndex, 1);
		}

		this.communication = keys.map((key) => ({
			control: (this.deleteAppointmentForm.get('Communication') as FormGroup).controls[key] as FormControl,
			label: translate(`COMMUNICATION.BEEGO.${key.toUpperCase()}`, { email: '' }),
		}));
	}
}
